import { client } from "./client";
import {
  FactotumCreateRequest,
  FactotumUpdateRequest,
} from "../types/Factotum";
import { FactotumStateCreateRequest, FactotumStateUpdateRequest } from "../types/FactotumState";
import { FactotumStateTieCreateRequest } from "../types/FactotumStateTie";

export function apiCreateFactotum(
  organizationId: number,
  workspaceId: number,
  factotumCreateRequest: FactotumCreateRequest
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/factotums`,
    factotumCreateRequest
  );
}

export function apiGetFactotums(
  organizationId: number,
  workspaceId: number
) {
  return client.get(
    `/organizations/${organizationId}/workspaces/${workspaceId}/factotums`
  );
}

export function apiUpdateFactotum(
  organizationId: number,
  workspaceId: number,
  factotumId: number,
  factotumUpdateRequest: FactotumUpdateRequest
) {
  return client.put(
    `/organizations/${organizationId}/workspaces/${workspaceId}/factotums/${factotumId}`,
    factotumUpdateRequest
  );
}

export function apiGetFactotumStates(
  organizationId: number,
  factotumId: number
) {
  return client.get(
    `/organizations/${organizationId}/factotums/${factotumId}/states`
  );
}

export function apiCreateFactotumState(
  organizationId: number,
  factotumId: number,
  factotumStateCreateRequest: FactotumStateCreateRequest
) {
  return client.post(
    `/organizations/${organizationId}/factotums/${factotumId}/states`,
    factotumStateCreateRequest
  );
}

export function apiUpdateFactotumState(
  organizationId: number,
  factotumId: number,
  stateId: number,
  factotumStateUpdateRequest: FactotumStateUpdateRequest
) {
  return client.put(
    `/organizations/${organizationId}/factotums/${factotumId}/states/${stateId}`,
    factotumStateUpdateRequest
  );
}

export function apiGetFactotumStateTies(
  organizationId: number,
  factotumId: number
) {
  return client.get(
    `/organizations/${organizationId}/factotums/${factotumId}/state_ties`
  );
}

export function apiCreateFactotumStateTie(
  organizationId: number,
  factotumId: number,
  factotumStateTieCreateRequest: FactotumStateTieCreateRequest
) {
  return client.post(
    `/organizations/${organizationId}/factotums/${factotumId}/state_ties`,
    factotumStateTieCreateRequest
  );
}
